import React, { Fragment } from "react";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserFriends, faUserCog } from '@fortawesome/free-solid-svg-icons';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip
} from "reactstrap";

const AdminNav = ({ path }) => {
  let location = useLocation()
  const [color, setColor] = React.useState(color);

  React.useEffect(
    () => {
      const newColor = window.location.pathname.includes(path) || window.location.pathname === "/" ? "primary" : "secondary";
      //console.log(window.location.pathname)
      setColor(newColor)
    },
    [location]
  )

  return (
    <Can
      roles={[roles.ADMIN]}
      yes={() => (
        <UncontrolledDropdown className="ml-1 mt-1">
          <DropdownToggle color={color} id="adminNavBtn" caret>
            <FontAwesomeIcon icon="users" /><span className="d-none d-xl-block">Amministrazione</span>
          </DropdownToggle>
          <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="adminNavBtn">
            Amministrazione
          </UncontrolledTooltip>
          <DropdownMenu>

            <DropdownItem
              tag={RouterNavLink}
              to={`${path}/users`}
              className="dropdown-profile"
              activeClassName="router-link-exact-active-nav"
            >
              <FontAwesomeIcon icon={faUserFriends} className="mr-1" /> Elenco Utenti
            </DropdownItem>

            <DropdownItem
              tag={RouterNavLink}
              to={`${path}/add-user`}
              className="dropdown-profile"
              activeClassName="router-link-exact-active-nav"
            >
              <FontAwesomeIcon icon="user-plus" className="mr-1" /> Aggiungi Utente
            </DropdownItem>

            <div className="divider my-2"></div>

            <DropdownItem
              tag={RouterNavLink}
              to={`/`}
              className="dropdown-profile"
              activeClassName={window.location.pathname === "/" ? "router-link-exact-active-nav" : "dropdown-profile"}
            >
              <FontAwesomeIcon icon="users-cog" className="mr-1" /> Elenco Dealer
            </DropdownItem>

            <DropdownItem
              tag={RouterNavLink}
              to={`${path}/add-tenant`}
              className="dropdown-profile"
              activeClassName="router-link-exact-active-nav"
            >
              <FontAwesomeIcon icon={faUserCog} className="mr-1" /> Crea Dealer
            </DropdownItem>

            <div className="divider my-2"></div>

            <DropdownItem
              tag={RouterNavLink}
              to={`${path}/products`}
              className="dropdown-profile"
              activeClassName="router-link-exact-active-nav"
            >
              <FontAwesomeIcon icon="align-center" className="mr-1" /> Prodotti
              </DropdownItem>

          </DropdownMenu>
        </UncontrolledDropdown>
      )}
      no={() => null}
    />
  );
};

export default AdminNav;
